import { createPromisifiedAction } from '../../common/actions-promisifier/create-promisified-action';

export const FETCH_CAPTCHA_REQUEST = 'FETCH_CAPTCHA_REQUEST';
export const FETCH_CAPTCHA_SUCCESS = 'FETCH_CAPTCHA_SUCCESS';
export const FETCH_CAPTCHA_FAILURE = 'FETCH_CAPTCHA_FAILURE';

export const VALIDATE_CAPTCHA_ANSWER_REQUEST = 'VALIDATE_CAPTCHA_ANSWER_REQUEST';
export const VALIDATE_CAPTCHA_ANSWER_SUCCESS = 'VALIDATE_CAPTCHA_ANSWER_SUCCESS';
export const VALIDATE_CAPTCHA_ANSWER_FAILURE = 'VALIDATE_CAPTCHA_ANSWER_FAILURE';

export const NULLIFY_CAPTCHA = 'NULLIFY_CAPTCHA';

export function nullifyCaptcha() {
  return {
    type: NULLIFY_CAPTCHA,
  };
}

export function fetchCaptcha() {
  return (dispatch, getState, { request }) => {
    dispatch({
      type: FETCH_CAPTCHA_REQUEST,
    });

    const promise = request(`/captcha`);

    return promise
      .then(captcha =>
        dispatch({
          type: FETCH_CAPTCHA_SUCCESS,
          payload: captcha,
        }),
      )
      .catch(() =>
        dispatch({
          type: FETCH_CAPTCHA_FAILURE,
        }),
      )
      .then(() => promise);
  };
}

export function validateCaptcha({ id, answer }) {
  return (dispatch, getState, { request }) => {
    dispatch({
      type: VALIDATE_CAPTCHA_ANSWER_REQUEST,
    });

    const promise = request.post(`/captcha`, { id, answer });

    return promise
      .then(reponse =>
        dispatch({
          type: VALIDATE_CAPTCHA_ANSWER_SUCCESS,
          payload: {
            isCorrect: reponse.ok,
            answer,
          },
        }),
      )
      .catch(() =>
        dispatch({
          type: VALIDATE_CAPTCHA_ANSWER_FAILURE,
        }),
      )
      .then(() => promise);
  };
}

export const fetchCaptchaPromisified = createPromisifiedAction(fetchCaptcha, response => response);
export const validateCaptchaPromisified = createPromisifiedAction(
  validateCaptcha,
  response => response,
);
